import { useMutation, useQuery } from '@tanstack/react-query';

import { doneTour, getTour } from '@/components/shared/components/auto-tour/services';

import { DONE_TOUR, GET_TOUR } from '@/constant/query-key';

export function useGetTour(currentUrl: string, previewId: string | null = null) {
  return useQuery({
    queryFn: () => getTour(currentUrl, previewId),
    queryKey: [GET_TOUR, currentUrl, previewId],
  });
}

export function useDoneTour() {
  return useMutation({
    mutationFn: (id: string) => doneTour(id),
    mutationKey: [DONE_TOUR],
  });
}
